import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
export const CheckSmall = ()=>/*#__PURE__*/ _jsx("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "currentColor",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ _jsx("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M6.57339 12C6.38862 11.9994 6.21237 11.9221 6.08673 11.7866L2.84673 8.33996H2.84673C2.59452 8.07119 2.60795 7.64884 2.87673 7.39663C3.1455 7.14442 3.56785 7.15785 3.82006 7.42663L6.56673 10.3533L12.1734 4.21996V4.21996C12.4039 3.93288 12.8235 3.88705 13.1106 4.11759C13.3977 4.34813 13.4435 4.76774 13.213 5.05482C13.1965 5.07534 13.1788 5.09487 13.1601 5.1133L7.06672 11.78C6.94225 11.9179 6.76585 11.9977 6.58006 12H6.57339Z"
        })
    });
